import { useTranslation } from "@coworker/locales";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { DatePicker } from "../../../components/DatePicker/DatePicker";
import { SelectOption, SelectOptionPeriod } from "../../types/filter";
import CustomPeriodCss from "./CustomPeriod.module.css";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const FORMAT = "YYYY-MM-DD";

interface CustomPeriodProps {
  onChange: (option: SelectOption) => void;
  selected: SelectOptionPeriod;
}

export const CustomPeriod = ({ onChange, selected }: CustomPeriodProps) => {
  const today = dayjs();
  const todayFormatted = today.format(FORMAT);

  const { startDate, endDate } = selected;

  const { t } = useTranslation();

  const handleStartDateChange = (value: string | null) => {
    const valueString = value ?? "";
    const newStart = dayjs(valueString);
    const currentEnd = dayjs(endDate);

    if (!endDate || newStart.isSameOrBefore(currentEnd)) {
      onChange({ ...selected, startDate: valueString });
    }
  };

  const handleEndDateChange = (value: string | null) => {
    const valueString = value ?? "";
    const newEnd = dayjs(valueString);
    const currentStart = dayjs(startDate);

    if (
      (!startDate || newEnd.isSameOrAfter(currentStart)) &&
      newEnd.isSameOrBefore(today)
    ) {
      onChange({ ...selected, endDate: valueString });
    }
  };

  return (
    <div className={CustomPeriodCss["custom-period"]}>
      <DatePicker
        label={t("startDateString")}
        value={startDate}
        onChange={handleStartDateChange}
        max={
          dayjs(endDate).isValid()
            ? dayjs(endDate).format(FORMAT)
            : todayFormatted
        }
      />
      <DatePicker
        label={t("endDateString")}
        value={endDate}
        onChange={handleEndDateChange}
        min={
          dayjs(startDate).isValid()
            ? dayjs(startDate).format(FORMAT)
            : todayFormatted
        }
        max={todayFormatted}
      />
    </div>
  );
};
